import React, { useCallback } from "react";
import themePropTypes from "../theme-prop-types";

const Pills = ({
  width,
  height = 40,
  justify = "start",
  options,
  value,
  onChange,
  name,
  invalid,
  disabled = [],
  isRadioGroup = false,
  label
}) => {
  const pillStyle = {
    height: `${height}px`
  };
  if (width) {
    pillStyle.width = `${width}px`;
  }

  const isDisabled = useCallback(
    index => disabled.some(i => i === index),
    [disabled]
  );

  const clickHandler = (selectedValue, index) => {
    if (!isDisabled(index)) {
      onChange(selectedValue);
    }
  };
  return (
    <div
      className={`pills-web-sdk websdk-justify-${justify}`}
      data-testid={`pills-wrapper-${name}`}
      role={isRadioGroup ? "radiogroup" : "listbox"}
      aria-label={label}
    >
      {options.map((option, index) =>
        isRadioGroup ? (
          <label
            htmlFor={`${name}-${option.value}`}
            style={pillStyle}
            key={option.value}
            className={`pill-web-sdk ${
              option.value === value ? "selected" : ""
            } ${invalid ? "invalid" : ""}`}
          >
            {option.text}
            <input
              id={`${name}-${option.value}`}
              type='radio'
              onChange={() => onChange(option.value)}
              value={option.value}
              name={name}
              checked={option.value === value}
              className='pill-radio-web-sdk'
            />
          </label>
        ) : (
          <button
            key={option.value}
            className={`pill-web-sdk ${
              option.value === value ? "selected" : ""
            } ${invalid ? "invalid" : ""}${
              isDisabled(index) ? " disabled" : ""
            }`}
            type='button'
            disabled={isDisabled(index)}
            onClick={() => clickHandler(option.value, index)}
            style={pillStyle}
            data-testid={`pill-button-${option.text}`}
            role='option'
            aria-selected={option.value === value ? "true" : "false"}
          >
            {option.text}
          </button>
        )
      )}
    </div>
  );
};

Pills.propTypes = themePropTypes.pills;

export default Pills;
